import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import ClientPaymentsListPage from './client-payments-list'

const accountingsRoutes: Route[] = [
  {
    path: Paths.CLIENT_PAYMENTS_LIST_PAGE,
    element: <ClientPaymentsListPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default accountingsRoutes
